import { Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FileExplorerService } from '../file-explorer.service';
import { FileItem } from '../models/fileItem';

@Component({
    selector: 'tree-node',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss'],
    standalone: false
})

export class TreeNodeComponent implements OnInit {

  @Input()
  public folder: FileItem

  constructor(public fileExplorerService: FileExplorerService) { }

  setSelected(node)
  {
    this.fileExplorerService.selected=node;
  }

  ngOnInit() { }
}


@Pipe({
    name: 'treeFolderFilter',
    pure: false,
    standalone: false
})
export class TreeFolderFilterPipe implements PipeTransform {

  transform(items: FileItem[], filter?: Object): any {
    if (!items) {
      return items;
    }

    return items.filter(item => (item.type.toString()=='dir'));
  }
}
